import { cx } from "@jugl-web/utils";
import { forwardRef, HTMLAttributes, ReactNode } from "react";

interface HeaderBreadcrumbsItemContainerProps
  extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  isLast?: boolean;
  className?: string;
  onClick?: () => void;
}

export const HeaderBreadcrumbsItemContainer = forwardRef<
  HTMLDivElement,
  HeaderBreadcrumbsItemContainerProps
>(({ children, isLast, className, onClick, ...props }, ref) => (
  <div
    ref={ref}
    className={cx(
      "font-secondary text-lg leading-5 font-normal whitespace-nowrap text-dark",
      !!onClick && "cursor-pointer",
      isLast && "truncate font-medium",
      className
    )}
    onClick={onClick}
    {...props}
  >
    {children}
  </div>
));
